import React from "react"
import RegistrationFlow from "../../../features/authentication/components/RegistrationFlow"
import { RedirectIfAuthenticated } from "../../../features/authentication/redirects"
import { EditorialLabel } from "../../../features/contents"
import { useQueryParam } from "../../../features/navigation/hooks/useQueryParam"
import { updateLoginDialogState } from "../../../features/ui/state/uiActions"
import { useAppDispatch } from "../../../state/store"
import CustomButton from "../../../ui/atoms/Button"
import Stroke from "../../../ui/atoms/Stroke"
import Typography from "../../../ui/atoms/Typography"
import {
  CustomBox,
  CustomCol,
  CustomContainer,
  CustomRow,
} from "../../../ui/spacings"

interface Props {
  contents: any
}

const RegistrationPageContainer = ({ contents }: Props) => {
  const dispatch = useAppDispatch()
  const redirectUrl = useQueryParam("returnUrl")

  const openLoginModal = () => {
    dispatch(updateLoginDialogState(true))
  }

  return (
    <>
      {!redirectUrl && <RedirectIfAuthenticated to="/profile" />}
      <CustomContainer style={{ minHeight: "70vh" }}>
        <CustomRow justify="center">
          <CustomCol xs={12} sm={4}>
            <CustomBox mt={6} mb={2}>
              <Typography variant="h4">
                {contents.data.contents?.title}
              </Typography>
              <Typography>{contents.data.contents?.subtitle}</Typography>
            </CustomBox>
            <RegistrationFlow />
            <Stroke color="disabled" className="my-8" />
            <div className="my-4">
              <div className="mb-4">
                <EditorialLabel
                  scope="account"
                  id="any-account-yet"
                  variant="subtitle1"
                />
              </div>
              <CustomButton
                variant="outlined"
                fullWidth
                onClick={openLoginModal}
              >
                <EditorialLabel scope="account" id="login" plainText />
              </CustomButton>
            </div>
          </CustomCol>
        </CustomRow>
      </CustomContainer>
    </>
  )
}

export default RegistrationPageContainer
